import React from "react";
import { connect } from "alt-react";
import BlockchainStore from "stores/BlockchainStore";
import SettingsStore from "stores/SettingsStore";
import Translate from "react-translate-component";
import WebsocketAddModal from "./Settings/WebsocketAddModal";
import SettingsActions from "actions/SettingsActions";
import { Apis } from "bitsharesjs-ws";
import { Form, Select, Button, Input } from "bitshares-ui-style-guide";
import counterpart from "counterpart";
const optionalApis = {
  enableCrypto: true,
  enableOrders: true
};

class InitError extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalVisible: false
    };
    this.handleModalClose = this.handleModalClose.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.rpc_connection_status === "open" && nextProps.apiServer !== this.props.apiServer) {
      SettingsActions.showWS(nextProps.apiServer);
    }
  }

  handleModalClose() {
    this.setState({
      isModalVisible: false
    });
  }

  triggerModal(e) {
    this.setState({
      isModalVisible: true
    });
  }

  onChangeWS(value) {
    SettingsActions.changeSetting({
      setting: "apiServer",
      value: value
    });
    Apis.reset(value, true, 4000, optionalApis);
  }

  onReloadClick(e) {
    if (e) {
      e.preventDefault();
    }

    if (window.electron) {
      window.location.hash = "";
      window.remote.getCurrentWindow().reload();
    } else window.location.href = __BASE_URL__;
  }

  onReset() {
    SettingsActions.changeSetting({
      setting: "apiServer",
      value: this.props.defaultConnection
    });
    SettingsActions.clearSettings();
  }

  render() {
    let uniqueNodes = this.props.apis.reduce((a, node) => {
      // node is the minimum requirement of filled data to connect
      if (!!node && !!node.url) {
        let exists = a.findIndex(n => {
          return n.url === node.url;
        }) !== -1;
        if (!exists) a.push(node);
      }

      return a;
    }, []);
    let selectOptions = uniqueNodes.map(entry => {
      let onlyDescription = entry.url.indexOf("fake.automatic-selection") !== -1;
      let {
        location
      } = entry;
      if (!!location && typeof location === "object" && "translate" in location) location = counterpart.translate(location.translate);
      return /*#__PURE__*/React.createElement(Select.Option, {
        key: entry.url,
        value: entry.url
      }, location || entry.url, " ", !onlyDescription && location ? `(${entry.url})` : null);
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "grid-block"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-content no-overflow"
    }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Translate, {
      component: "h3",
      content: `app_init.title`
    }), /*#__PURE__*/React.createElement(Form, {
      layout: "vertical"
    }, /*#__PURE__*/React.createElement(Form.Item, {
      label: counterpart.translate("settings.apiServer")
    }, /*#__PURE__*/React.createElement(Input.Group, {
      compact: true
    }, /*#__PURE__*/React.createElement(Select, {
      style: {
        width: "calc(100% - 175px)"
      },
      onChange: this.onChangeWS.bind(this),
      value: this.props.apiServer
    }, selectOptions), /*#__PURE__*/React.createElement(Button, {
      id: "add",
      style: {
        width: "175px"
      },
      onClick: this.triggerModal.bind(this),
      icon: "plus"
    }, counterpart.translate("settings.add_api")))), /*#__PURE__*/React.createElement(Form.Item, {
      label: counterpart.translate("app_init.ws_status")
    }, this.props.rpc_connection_status === "open" ? /*#__PURE__*/React.createElement("span", {
      className: "txtlabel success"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: `app_init.connected`
    })) : /*#__PURE__*/React.createElement("span", {
      className: "txtlabel warning"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: `app_init.not_connected`
    }))), /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      onClick: this.onReloadClick
    }, counterpart.translate(`app_init.retry`)), /*#__PURE__*/React.createElement(Button, {
      style: {
        marginLeft: "16px"
      },
      onClick: this.onReset.bind(this)
    }, counterpart.translate(`settings.reset`))), /*#__PURE__*/React.createElement(WebsocketAddModal, {
      ref: "ws_modal",
      isAddNodeModalVisible: this.state.isModalVisible,
      onAddNodeClose: this.handleModalClose,
      apis: this.props.apis
    }))));
  }

}

export default connect(InitError, {
  listenTo() {
    return [BlockchainStore, SettingsStore];
  },

  getProps() {
    return {
      rpc_connection_status: BlockchainStore.getState().rpc_connection_status,
      apis: SettingsStore.getState().defaults.apiServer,
      apiServer: SettingsStore.getState().settings.get("apiServer"),
      defaultConnection: SettingsStore.getState().defaultSettings.get("apiServer")
    };
  }

});